export default {"src":"/_next/static/media/home-delivery.mono.41f007e7.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};